import { ProductosState, ProductosActionTypes, SET_PRODUCTS } from './types';

const initialState: ProductosState = {
    products: []
};

export function productosReducer(
    state = initialState,
    action: ProductosActionTypes
): ProductosState {
    switch (action.type) {
        case SET_PRODUCTS:
            return { ...state, products: action.payload };
        default:
            return state;
    }
}